import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { Question } from '@/types/form'

interface QuestionSettingsProps {
  question: Question
  onChange: (patch: Partial<Question['settings']>) => void
}

export function DateSettings({ question, onChange }: QuestionSettingsProps) {
  if (question.type === 'TIME') {
    return (
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Label>時間提示</Label>
          <Input
            value={question.settings.placeholder ?? ''}
            placeholder="例如：09:30"
            onChange={(event) => onChange({ placeholder: event.target.value })}
          />
          <p className="text-xs text-slate-500">
            填答頁會使用瀏覽器原生時間選擇器，並顯示 24 小時制提示。
          </p>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="flex flex-col gap-2">
            <Label>最早時間</Label>
            <Input
              type="time"
              value={question.settings.timeMin ?? ''}
              onChange={(event) => onChange({ timeMin: event.target.value })}
            />
          </div>
          <div className="flex flex-col gap-2">
            <Label>最晚時間</Label>
            <Input
              type="time"
              value={question.settings.timeMax ?? ''}
              onChange={(event) => onChange({ timeMax: event.target.value })}
            />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <Label>選擇間隔（分鐘）</Label>
          <Input
            type="number"
            min={1}
            value={question.settings.timeStepMinutes ?? ''}
            placeholder="例如：15"
            onChange={(event) =>
              onChange({
                timeStepMinutes:
                  event.target.value.trim() === '' ? undefined : Number(event.target.value),
              })
            }
          />
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Label>格式</Label>
        <Select
          value={String(question.settings.dateFormat ?? 'date')}
          onValueChange={(dateFormat) => onChange({ dateFormat })}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="date">日期</SelectItem>
            <SelectItem value="datetime">日期 + 時間</SelectItem>
            <SelectItem value="month">月份</SelectItem>
            <SelectItem value="year">年份</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="flex flex-col gap-2">
          <Label>最早日期</Label>
          <Input type="date" onChange={(event) => onChange({ minDate: event.target.value })} />
        </div>
        <div className="flex flex-col gap-2">
          <Label>最晚日期</Label>
          <Input type="date" onChange={(event) => onChange({ maxDate: event.target.value })} />
        </div>
      </div>
    </div>
  )
}
